/* eslint-disable react/no-danger */
import React from 'react';
import { arrayOf, node, oneOfType, string } from 'prop-types';
import { v4 as uuidv4 } from 'uuid';

import exportWithBoundary from '../../../helpers/exportWithBoundary';
import Button from '../Button';
import { ButtonGroupContainer } from './styles';

function ButtonGroup({ children, buttonType, buttonStyle, size }) {
  return (
    <ButtonGroupContainer>
      {children.map((btn) => {
        const btnProps = { ...btn.props };
        if (!btnProps.key) {
          btnProps.key = uuidv4();
        }
        if (size) {
          btnProps.size = size;
        }
        if (buttonType && !btn.props.buttonType) {
          btnProps.buttonType = buttonType;
        }
        if (buttonStyle) {
          btnProps.buttonStyle = buttonStyle;
        }
        return <Button {...btnProps} />;
      })}
    </ButtonGroupContainer>
  );
}

ButtonGroup.defaultProps = {
  buttonStyle: 'raised',
  buttonType: 'primary',
  size: null,
};

ButtonGroup.propTypes = {
  buttonStyle: string,
  buttonType: string,
  children: oneOfType([arrayOf(node), node]).isRequired,
  size: string,
};

function ButtonGroupFallback() {
  return <span />;
}

export default exportWithBoundary(ButtonGroup, ButtonGroupFallback);
